<template>
    <transition name="fade">
        <div class="popup-modal" v-if="isVisible" @click="dissmiss()">
            <div ref="dialog" class="window" @click.stop>
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "ModalDialog",
    props: ["backdrop"],
    data: () => ({
        isVisible: false,
    }),

    methods: {
        open() {
            this.isVisible = true
        },

        close() {
            this.isVisible = false
        },
        dissmiss() {
            const dialog = this.$refs.dialog;
            if (this.backdrop === 'static') {
                dialog.classList.add('modal-static');
                dialog.addEventListener('animationend', () => {
                    dialog.classList.remove('modal-static');
                }, { once: true });
            } else {
                this.close();
            }
        }
    },
}
</script>

<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active .window,
.fade-leave-active .window {
    -webkit-animation: slide-in-top .3s ease-out;
    animation: slide-in-top .3s ease-out;
}

.fade-enter .window,
.fade-leave-to .window {
    -webkit-animation: slide-out-top .3s ease-out;
    animation: slide-out-top .3s ease-out;
}

.popup-modal {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1055;
}

.window {
    background: #fff;
    border-radius: 16px;
    box-shadow: inset 0 4px 0 rgba(231, 231, 231, 0.25);
    max-width: 504px;
    position: relative;
    text-align: center;
    min-width: 326px;
}

@-webkit-keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@-webkit-keyframes slide-out-top {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }
}

@keyframes slide-out-top {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(-50px);
        transform: translateY(-50px);
        opacity: 0;
    }
}

.modal-static {
    -webkit-animation: scale-up .3s ease-out;
    animation: scale-up .3s ease-out;
}
@-webkit-keyframes scale-up {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    50% {
        -webkit-transform: scale(1.02);
        transform: scale(1.02);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes scale-up {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    50% {
        -webkit-transform: scale(1.02);
        transform: scale(1.02);
    }

    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>